import { useQuery } from '@tanstack/react-query';

import { getTaskComments } from 'services/task';

import { QUERY_KEYS } from '.';

export const useInitiativeCommentsData = ({ id, enabled, limit = 10, offset = 0, keepPreviousData = false }) =>
  useQuery(
    [QUERY_KEYS.INITIATIVE_COMMENTS, id, offset, limit],
    async () =>
      getTaskComments({
        limit,
        offset,
        taskId: id,
      }),
    { enabled, keepPreviousData }
  );
